
// src/actions/block.js

import api from './gamba-api'
import { emitAlertMessage, clearAlertMessage } from './alert-message'

export const FETCH_BLOCK_DIARIES = "FETCH_BLOCK_DIARIES"
export const FETCH_BLOCK_DIARIES_REQUESTED = "FETCH_BLOCK_DIARIES_REQUESTED"
export const FETCH_BLOCK_DIARIES_COMPLETED = "FETCH_BLOCK_DIARIES_COMPLETED"
export const FETCH_BLOCK_DIARIES_FAILED = "FETCH_BLOCK_DIARIES_FAILED"

export function fetchBlockDiariesRequested() {
  return {
    type: FETCH_BLOCK_DIARIES_REQUESTED
  }
}

export function fetchBlockDiaries() {
  return function(dispatch) {
    dispatch(fetchBlockDiariesRequested())
    return api.get(`/block/diaries`)
        .then((results)=> {
          dispatch(fetchBlockDiariesCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchBlockDiariesFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchBlockDiariesCompleted(results) {
  return {
    type: FETCH_BLOCK_DIARIES_COMPLETED,
    results,
  }
}

export function fetchBlockDiariesFailed(error) {
  return {
    type: FETCH_BLOCK_DIARIES_FAILED,
    error,
  }
}

export const FETCH_BLOCK_USERS = "FETCH_BLOCK_USERS"
export const FETCH_BLOCK_USERS_REQUESTED = "FETCH_BLOCK_USERS_REQUESTED"
export const FETCH_BLOCK_USERS_COMPLETED = "FETCH_BLOCK_USERS_COMPLETED"
export const FETCH_BLOCK_USERS_FAILED = "FETCH_BLOCK_USERS_FAILED"

export function fetchBlockUsersRequested() {
  return {
    type: FETCH_BLOCK_USERS_REQUESTED
  }
}

export function fetchBlockUsers() {
  return function(dispatch) {
    dispatch(fetchBlockUsersRequested())
    return api.get(`/block/users`)
        .then((results)=> {
          dispatch(fetchBlockUsersCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchBlockUsersFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchBlockUsersCompleted(results) {
  return {
    type: FETCH_BLOCK_USERS_COMPLETED,
    results,
  }
}

export function fetchBlockUsersFailed(error) {
  return {
    type: FETCH_BLOCK_USERS_FAILED,
    error,
  }
}

export const UPDATE_BLOCK_DIARY = "UPDATE_BLOCK_DIARY"
export const UPDATE_BLOCK_DIARY_REQUESTED = "UPDATE_BLOCK_DIARY_REQUESTED"
export const UPDATE_BLOCK_DIARY_COMPLETED = "UPDATE_BLOCK_DIARY_COMPLETED"
export const UPDATE_BLOCK_DIARY_FAILED = "UPDATE_BLOCK_DIARY_FAILED"

export function updateBlockDiaryRequested() {
  return {
    type: UPDATE_BLOCK_DIARY_REQUESTED
  }
}

export function updateBlockDiary(diary_id, block) {
  return function(dispatch) {
    dispatch(updateBlockDiaryRequested())
    return api.put(`/block/diaries/${diary_id}`, { block })
        .then((results)=> {
          dispatch(updateBlockDiaryCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(updateBlockDiaryFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function updateBlockDiaryCompleted(results) {
  return {
    type: UPDATE_BLOCK_DIARY_COMPLETED,
    results,
  }
}

export function updateBlockDiaryFailed(error) {
  return {
    type: UPDATE_BLOCK_DIARY_FAILED,
    error,
  }
}

export const UPDATE_BLOCK_USER = "UPDATE_BLOCK_USER"
export const UPDATE_BLOCK_USER_REQUESTED = "UPDATE_BLOCK_USER_REQUESTED"
export const UPDATE_BLOCK_USER_COMPLETED = "UPDATE_BLOCK_USER_COMPLETED"
export const UPDATE_BLOCK_USER_FAILED = "UPDATE_BLOCK_USER_FAILED"

export function updateBlockUserRequested() {
  return {
    type: UPDATE_BLOCK_USER_REQUESTED
  }
}

export function updateBlockUser(user_id, block) {
  return function(dispatch) {
    dispatch(updateBlockUserRequested())
    return api.put(`/block/users/${user_id}`, { block })
        .then((results)=> {
          dispatch(updateBlockUserCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(updateBlockUserFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function updateBlockUserCompleted(results) {
  return {
    type: UPDATE_BLOCK_USER_COMPLETED,
    results,
  }
}

export function updateBlockUserFailed(error) {
  return {
    type: UPDATE_BLOCK_USER_FAILED,
    error,
  }
}

export const CLEAR_BLOCK_USERS = "CLEAR_BLOCK_USERS"

export function clearBlockUsers() {
  return {
    type: CLEAR_BLOCK_USERS
  }
}



// WEBPACK FOOTER //
// ./src/actions/block.js